import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { Button, Icon, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../store/actions';
import { connect } from 'react-redux';

/* drag sources */
const itemSource = {
    beginDrag(props) {
        // console.log(props)
        return props.item;
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        let target = monitor.getDropResult()

        if (props.item.WeekNum === target.week && props.item.DayOfWeek === target.day) {
            return true
        }
        if (props.item.module_id) {
            props.toggleConfirmDragDialog(props.item, target.week, target.day)
        }
        else {
            props.onDrop(props.item, target.week, target.day)
        }
        return true
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

class DraggableSelectedLesson extends Component {

    state = { deleteDialog: false }

    render() {
        let { connectDragSource, isDragging, item } = this.props;
        return (
            connectDragSource(
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>

                    <SnackbarContent 
                        style={{ backgroundColor: item.lesson_id === 'blank_lesson' ? '#FF4136': '#DDDDDD', maxWidth: '100%', minWidth: '90%', color: 'black', fontSize: '12px', cursor: 'move' }}
                        message={<div>{item.LessonName} <p style={{ fontSize: '10px' }}>{item.module_id ? item.module_name : null}</p></div>}
                        action={
                            <div>
                                <IconButton
                                    onClick={(ev) => {
                                        this.props.toggleLessonDialog(true, item);
                                    }}
                                >
                                    <Icon style={{fontSize: '16px'}}>build</Icon>
                                </IconButton>
                                <IconButton
                                    onClick={(ev) => {
                                        if (this.props.item.module_id) {
                                            this.setState({ deleteDialog: true })
                                        }
                                        else {
                                            this.props.deleteLesson(this.props.item);
                                        }
                                    }}
                                >
                                    <Icon style={{fontSize: '16px'}}>delete</Icon>
                                </IconButton>
                            </div>
                        }
                    />
                </div>)
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        deleteLesson: Actions.deleteLesson,
        toggleLessonDialog: Actions.toggleLessonDialog
    }, dispatch);
}

function mapStateToProps({ moduleApp }) {
    return {

    }
}


export default DragSource('item', itemSource, collectSource)(withRouter(connect(mapStateToProps, mapDispatchToProps)(DraggableSelectedLesson)));


// WEBPACK FOOTER //
// src/main/content/course/builderComponents/BuilderDraggableLesson.js